<template>
  <div class="cash-out-registration-fee">

    <div class="page-content-wrapper choose-career-screen mb-3">
      <div class="container">


            <div class="row mb-3">

              <div class="col-md-6">

                <div class="card">
                  <div class="card-block">

                    <h4 class="mt-0 header-title">Datos personales</h4>

                    <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>
                    <div class="alert alert-success p-3" role="alert" v-if="isLoading"><i class="fa fa-spin fa-circle-o-notch"></i> Cargando...</div>

                    <div class="row">
                      <div class="form-group mb-3 col-md-5">
                        <label>Apellido</label>
                        <input type="text" class="form-control" v-if="registrationToCareer" readonly v-model="registrationToCareer.studentFile.personalData.lastName">
                      </div>

                      <div class="form-group mb-3 col-md-7">
                        <label>Nombre</label>
                        <input type="text" class="form-control" v-if="registrationToCareer" readonly v-model="registrationToCareer.studentFile.personalData.firstName">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group mb-3 col-md-6">
                        <label>Dni</label>
                        <input type="text" class="form-control" v-if="registrationToCareer" readonly v-model="registrationToCareer.studentFile.personalData.dni">
                      </div>

                      <div class="form-group mb-3 col-md-6">
                        <label>Cuil</label>
                        <input type="text" class="form-control" v-if="registrationToCareer" readonly v-model="registrationToCareer.studentFile.personalData.cuil">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group mb-3 col-md-12">
                        <label>Email</label>
                        <input type="text" class="form-control" v-if="registrationToCareer" readonly v-model="registrationToCareer.studentFile.personalData.email">
                      </div>
                    </div>


                    <h4 class="mt-4 header-title">Datos académicos</h4>

                    <div class="row">
                      <div class="form-group mb-3 col-md-12">
                        <label>Carrera</label>
                        <select id="career" class="custom-select form-control" disabled v-if="registrationToCareer" v-model="registrationToCareer.career._id">
                          <option v-for="career in careers" v-bind:value="career._id">
                            {{ career.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group mb-3 col-md-6">
                        <label>Nivel</label>
                        <select id="level" class="custom-select form-control" disabled v-if="registrationToCareer" v-model="registrationToCareer.level">
                          <option v-for="level in levels" v-bind:value="level.value">
                            {{ level.text }}
                          </option>
                        </select>
                      </div>
                    </div>



                  </div>
                </div>

              </div>


              <div class="col-md-6">

                <div class="card">
                  <div class="card-block">

                    <h4 class="mt-0 header-title">Cobro de matrícula</h4>

                    <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>
                    <div class="alert alert-success p-3" role="alert" v-if="isLoading"><i class="fa fa-spin fa-circle-o-notch"></i> Cargando...</div>
                    <div class="alert alert-success p-3" role="alert" v-if="savedSuccessfully">Los datos se han guardado.</div>


                    <div class="row">
                      <div class="form-group mb-3 col-md-12">
                        <label>Numero de recibo</label>
                        <div class="form-group" style="margin: auto;" v-bind:class="{ 'has-danger': $v.receiptNumber.$error }">
                          <input type="text" @keyup.enter="submit()" class="form-control mb-2 mr-sm-2 mb-sm-0 col-md-6" v-model="receiptNumber">
                          <div class="form-control-feedback" v-if="!$v.receiptNumber.required && $v.receiptNumber.$error">Ingresar el número de recibo.</div>
                        </div>
                      </div>

                      <div class="form-group mb-3 col-md-12">
                        <label>Metodo de pago</label>
                        <div class="form-group" style="margin: auto;">
                          <span class="badge badge-success">Efectivo</span>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3 pull-right">
                      <div class="col-md-12">
                        <div class="loading waves-effect mr-2" v-if="isSaving">
                          <i class="fa fa-spin fa-circle-o-notch"></i>
                        </div>
                        <button class="btn btn-secondary" @click="cancel()">Cancelar</button>
                        <button class="btn btn-primary save-btn" @click="submit()">Guardar</button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>



      </div>
    </div>
  </div>

</template>
<script>
  import { required } from 'vuelidate/lib/validators'
  import levels from '../data/levels'

  export default {

    name: 'approve-registration-to-careers',




    created(){

      this.getAllCareers()
      this.getRegistrationToCareer()

    },



    data () {
      return {
        isLoading: false,
        isSaving: false,
        savedSuccessfully: false,
        error: false,
        receiptNumber: '',
        levels: levels
      }
    },


    computed: {

      registrationToCareer: function () {
        return this.$store.getters.getRegistrationToCareer
      },

      careers: function () {
        return this.$store.getters.getAllCareers
      }

    },



    validations: {
      receiptNumber: {
        required
      }
    },



    methods:{


      getAllCareers () {
        this.isLoading = true
        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.isLoading = false
          })
          .catch((response) => {
            this.isLoading = false
            this.error = 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'
          })
      },



      getRegistrationToCareer: function () {

        var self = this;
        this.isLoading = true

        this.$store.dispatch('getRegistrationToCareer', { registrationToCareer: { _id: this.$route.params.id } })
          .then((response) => {
            if (response.success) {
              if(self.registrationToCareer.payment) {
                self.receiptNumber = self.registrationToCareer.payment.receiptNumber;
              }
            }
          })
          .catch((response) => {
            this.error = 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'
            this.isLoading = false
          })

      },






      validate () {
        this.$v.receiptNumber.$touch();
        return !this.$v.receiptNumber.$error;
      },


      submit () {

        const self = this
        this.savedSuccessfully = false;
        this.isSaving = true;
        this.error = null;

        if ( this.validate() ) {

          var params = {
            _id: this.$route.params.id,
            progress: {
              enrolled: true
            },
            payment: {
              receiptNumber: self.receiptNumber
            }
          };

          $('.save-btn').attr('disabled', true)

          this.$store.dispatch('editRegistrationToCareer', {registrationToCareer: params})
            .then((response) => {

              if (response.success) {
                self.savedSuccessfully = true;

                setTimeout(function () {
                  self.$router.push('/list-registration-to-careers')
                }, 1000)


              } else {
                self.error = response.message

              }

              $('.save-btn').attr('disabled', false)
              self.isSaving = false;

            })
            .catch((error) => {
              this.error = 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'
              $('.save-btn').attr('disabled', false)
              self.isSaving = false;
            })
        }

      },


      cancel () {
        this.$router.push('/list-registration-to-careers')
      }

    }

  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/screens/RegistrationFeeScreenInCash.vue